import {Injectable} from '@angular/core';
import {GLOBAL} from './global.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {map} from "rxjs/operators";

@Injectable()
export class BasketService {
    public url: string;
    public token;
    public service: string = 'basket';

    constructor(
        private _http: HttpClient
    ) {
        this.url = GLOBAL.url;
    }

    realizarCompra(carrito) {
        let c = JSON.stringify(carrito);
        return this._http.post(this.url + this.service + '/realizarCompra', c, {
            responseType: 'text',
            observe: 'response',
            headers: new HttpHeaders()
        })
            .pipe(map(res => res));
    }

    get(id) {
        let params: HttpParams = new HttpParams();
        return this._http.get(this.url + this.service + '/' + id,
            { responseType: 'text', observe: 'response', headers: new HttpHeaders(), params: params }).pipe(map(res => {
            return res
        }));
    }
}
